// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DocumentForm_contract__yAj-4 {
  margin-bottom: 12px;
}

.DocumentForm_collapsible-title__IRra- {
  margin-left: 8px;
}

.DocumentForm_summary-first-line__nv\\+JP {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.DocumentForm_summary-first-line__nv\\+JP .DocumentForm_first-line-element__TnZmF {
  margin-bottom: 0;
}

.DocumentForm_form__R3v1H {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 28px;
}

.DocumentForm_documents__V50Qw {
  display: flex;
  gap: 80px;
  width: 100%;
}

.DocumentForm_required-documents__mQslg {
  color: #000093;
  display: initial;
}
.DocumentForm_required-documents__mQslg ul {
  padding: 0;
  margin: 5px 0 0 0;
}
.DocumentForm_required-documents__mQslg ul li {
  padding: 0;
  font-size: 16px;
  line-height: 28px;
  list-style-type: none;
  display: flex;
  justify-content: space-between;
  padding: 7px 0;
}
.DocumentForm_required-documents__mQslg ul li:not(:first-child) {
  border-top: 1px solid #d8d8ff;
}
.DocumentForm_required-documents__mQslg ul li:last-child {
  padding-bottom: 0;
}
.DocumentForm_required-documents__mQslg ul li legend {
  display: flex;
}
.DocumentForm_required-documents__mQslg ul li div {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #1414ff;
}
.DocumentForm_required-documents__mQslg ul li div span {
  margin-left: 8px;
}

.DocumentForm_infoMessage__wk48K {
  margin-bottom: 12px;
}

.DocumentForm_info-circle__DMI42 {
  min-width: 20px;
  height: 20px;
}

.DocumentForm_upload__4ogyr {
  width: 73%;
}

.DocumentForm_upload-button__l\\+HCD {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 584px;
  height: 56px;
  gap: 8px;
}

.DocumentForm_uploaded-documents__JO5Oq {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.DocumentForm_document__9WgwU {
  display: flex;
  align-items: center;
  padding: 0 4px;
  border-radius: 4px;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
  background: #f9f9fa;
  color: #00007a;
}

.DocumentForm_close__ZREwL {
  width: 20px;
  cursor: pointer;
}

.DocumentForm_button__\\+hUXY {
  width: 200px;
  margin-top: 40px;
}

.DocumentForm_cards__iZ\\+C\\+ {
  list-style-type: none;
  font-weight: 300;
  padding: 0;
  margin: 0;
}

@media screen and (max-width: 600px) {
  .DocumentForm_documents__V50Qw {
    flex-direction: column;
    gap: 12px;
  }
  .DocumentForm_required-documents__mQslg {
    width: 100%;
    padding: 0 8px;
  }
  .DocumentForm_upload__4ogyr {
    width: 100%;
  }
  .DocumentForm_upload-button__l\\+HCD {
    height: 44px;
  }
  .DocumentForm_uploaded-documents__JO5Oq {
    margin-top: 12px;
  }
  .DocumentForm_button__\\+hUXY {
    width: 100%;
    margin-top: 32px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Claims/ClaimApplication/DocumentForm/DocumentForm.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,mBAAA;AAIF;;AADA;EACE,gBAAA;AAIF;;AADA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAIF;AAFE;EACE,gBAAA;AAIJ;;AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AAGF;;AAAA;EACE,aAAA;EACA,SAAA;EACA,WAAA;AAGF;;AAAA;EACE,cC9BS;ED+BT,gBAAA;AAGF;AADE;EACE,UAAA;EACA,iBAAA;AAGJ;AADI;EACE,UAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,aAAA;EACA,8BAAA;EACA,cAAA;AAGN;AADM;EACE,6BAAA;AAGR;AAAM;EACE,iBAAA;AAER;AACM;EACE,aAAA;AACR;AAEM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cChEG;ADgEX;AAEQ;EACE,gBAAA;AAAV;;AAOA;EACE,mBAAA;AAJF;;AAOA;EACE,eAAA;EACA,YAAA;AAJF;;AAOA;EACE,UAAA;AAJF;;AAOA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,QAAA;AAJF;;AAOA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBCtGS;EDuGT,cC9GS;AD0GX;;AAOA;EACE,WAAA;EACA,eAAA;AAJF;;AAOA;EACE,YAAA;EACA,gBAAA;AAJF;;AAOA;EACE,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AAJF;;AAOA;EACE;IACE,sBAAA;IACA,SAAA;EAJF;EAOA;IACE,WAAA;IACA,cAAA;EALF;EAQA;IACE,WAAA;EANF;EASA;IACE,YAAA;EAPF;EAUA;IACE,gBAAA;EARF;EAWA;IACE,WAAA;IACA,gBAAA;EATF;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.contract {\n  margin-bottom: 12px;\n}\n\n.collapsible-title {\n  margin-left: 8px;\n}\n\n.summary-first-line {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n\n  .first-line-element {\n    margin-bottom: 0;\n  }\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 28px;\n}\n\n.documents {\n  display: flex;\n  gap: 80px;\n  width: 100%;\n}\n\n.required-documents {\n  color: colors.$primary7;\n  display: initial;\n  \n  ul{\n    padding: 0;\n    margin: 5px 0 0 0;\n\n    li {\n      padding: 0;\n      font-size: 16px;\n      line-height: 28px;\n      list-style-type: none;\n      display: flex;\n      justify-content: space-between;\n      padding: 7px 0;\n\n      &:not(:first-child){\n        border-top: 1px solid colors.$primary2;\n      }\n\n      &:last-child{\n        padding-bottom: 0;\n      }\n\n      legend{\n        display: flex;\n      }\n\n      div {\n        display: flex;\n        align-items: center;\n        cursor: pointer;\n        color: colors.$primary5;\n    \n        span{\n          margin-left: 8px;\n        }\n      }\n    }\n  }\n}\n\n.infoMessage{\n  margin-bottom: 12px;\n}\n\n.info-circle {\n  min-width: 20px;\n  height: 20px;\n}\n\n.upload {\n  width: 73%;\n}\n\n.upload-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  max-width: 584px;\n  height: 56px;\n  gap: 8px;\n}\n\n.uploaded-documents {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.document {\n  display: flex;\n  align-items: center;\n  padding: 0 4px;\n  border-radius: 4px;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 28px;\n  background: colors.$neutral2;\n  color: colors.$primary8;\n}\n\n.close {\n  width: 20px;\n  cursor: pointer;\n}\n\n.button {\n  width: 200px;\n  margin-top: 40px;\n}\n\n.cards{\n  list-style-type: none;\n  font-weight: 300;\n  padding: 0;\n  margin: 0;\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .documents {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .required-documents {\n    width: 100%;\n    padding: 0 8px;\n  }\n\n  .upload {\n    width: 100%;\n  }\n\n  .upload-button {\n    height: 44px;\n  }\n\n  .uploaded-documents {\n    margin-top: 12px;\n  }\n\n  .button {\n    width: 100%;\n    margin-top: 32px;\n  }\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"contract": `DocumentForm_contract__yAj-4`,
	"collapsible-title": `DocumentForm_collapsible-title__IRra-`,
	"summary-first-line": `DocumentForm_summary-first-line__nv+JP`,
	"first-line-element": `DocumentForm_first-line-element__TnZmF`,
	"form": `DocumentForm_form__R3v1H`,
	"documents": `DocumentForm_documents__V50Qw`,
	"required-documents": `DocumentForm_required-documents__mQslg`,
	"infoMessage": `DocumentForm_infoMessage__wk48K`,
	"info-circle": `DocumentForm_info-circle__DMI42`,
	"upload": `DocumentForm_upload__4ogyr`,
	"upload-button": `DocumentForm_upload-button__l+HCD`,
	"uploaded-documents": `DocumentForm_uploaded-documents__JO5Oq`,
	"document": `DocumentForm_document__9WgwU`,
	"close": `DocumentForm_close__ZREwL`,
	"button": `DocumentForm_button__+hUXY`,
	"cards": `DocumentForm_cards__iZ+C+`
};
export default ___CSS_LOADER_EXPORT___;
